import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, BookOpenCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Flashcards() {
  const [cards, setCards] = useState([]);
  const [idx, setIdx] = useState(0);
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    api.get("/flashcards/daily?n=8").then((r) => setCards(r.data.cards || [])).catch(() => {});
  }, []);

  if (!cards.length) {
    return (
      <section
        className="bg-white border border-slate-200 rounded-xl p-5 md:p-6"
        data-testid="flashcards-loading"
      >
        <div className="h-5 w-32 bg-slate-100 rounded mb-3 animate-pulse" />
      </section>
    );
  }

  const card = cards[idx];
  const prev = () => { setIdx((idx - 1 + cards.length) % cards.length); setFlipped(false); };
  const next = () => { setIdx((idx + 1) % cards.length); setFlipped(false); };

  return (
    <section
      className="bg-white border border-slate-200 rounded-xl p-5 md:p-6"
      aria-labelledby="flashcards-h2"
      data-testid="flashcards"
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="inline-grid place-items-center w-8 h-8 rounded-md bg-orange-100 text-orange-700">
          <BookOpenCheck className="w-4 h-4" aria-hidden="true" />
        </span>
        <h2
          id="flashcards-h2"
          className="text-lg md:text-xl font-extrabold text-slate-900"
          style={{ fontFamily: "'Cabinet Grotesk',sans-serif" }}
        >
          Vocab &amp; GK Flashcards
        </h2>
      </div>
      <p className="text-xs text-slate-600 mb-3">
        Tap the card to flip. 8 fresh cards every day.
      </p>

      <button
        type="button"
        onClick={() => setFlipped((f) => !f)}
        data-testid="flashcard-flip"
        className="block w-full min-h-[160px] rounded-xl border border-slate-200 bg-gradient-to-br from-slate-50 to-white px-4 py-5 text-left hover:shadow-md transition-shadow"
        aria-label="Flip flashcard"
      >
        <div className="text-[11px] font-bold uppercase tracking-wider text-orange-600 mb-2">
          {flipped ? "Answer" : "Question"} · {card.topic}
        </div>
        <div className="text-sm md:text-base text-slate-900 font-semibold leading-snug">
          {flipped ? card.back : card.front}
        </div>
        {flipped && card.explain && (
          <div className="mt-3 text-xs text-slate-600 leading-relaxed">
            {card.explain}
          </div>
        )}
      </button>

      <div className="mt-4 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={prev}
          data-testid="flashcard-prev"
          className="inline-flex items-center gap-1 min-h-11 px-3 py-2 rounded-md border border-slate-300 hover:bg-slate-50 text-sm font-semibold"
        >
          <ChevronLeft className="w-4 h-4" /> Prev
        </button>
        <span className="text-xs font-bold text-slate-600">
          {idx + 1} / {cards.length}
        </span>
        <button
          type="button"
          onClick={next}
          data-testid="flashcard-next"
          className="inline-flex items-center gap-1 min-h-11 px-3 py-2 rounded-md border border-slate-300 hover:bg-slate-50 text-sm font-semibold"
        >
          Next <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
}
